import { __awaiter, __generator } from "tslib";
import { fetchPostAsResponse } from '../../../common';
import { getAuthBearerValue } from '../../../common/utilities';
import { getWebStoreApiConfig } from '../config/actions';
import { getTokenFromHeaders } from './get-token-from-headers';
import { validateJWTToken } from './validate-jwt-token';
import { isTokenExpired } from './is-token-expired';
import { refreshToken } from './refresh-token';
/**
 * Gets authorized JWT from either storage or Web Store API.
 * If JWT in storage is about to be expired it will be refreshed.
 * @param accessToken Access JWT to authorize (UIP)
 * @param guestToken Guest JWT to associate with authorized one
 * @returns Promise with authorized JWT
 */
export var getAuthToken = function (accessToken, guestToken) { return __awaiter(void 0, void 0, void 0, function () {
    var storage, storedToken, token, _a, baseUrl, marketLocale, siteContext, body, headers, response;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                storage = getWebStoreApiConfig().storage;
                storedToken = storage.getItem("web-store-auth-token" /* WebStoreAuthToken */);
                if (storedToken && validateJWTToken(storedToken)) {
                    return [2 /*return*/, storedToken];
                }
                if (!(storedToken && !isTokenExpired(storedToken))) return [3 /*break*/, 2];
                return [4 /*yield*/, refreshToken(storedToken, accessToken)];
            case 1:
                // If token is not expired then it will be refreshed.
                token = _b.sent();
                return [3 /*break*/, 4];
            case 2:
                _a = getWebStoreApiConfig(), baseUrl = _a.baseUrl, marketLocale = _a.marketLocale, siteContext = _a.siteContext;
                body = { brand: siteContext, guestToken: guestToken, marketLocale: marketLocale };
                headers = new Headers();
                headers.set("Authorization" /* Authorization */, getAuthBearerValue(accessToken));
                return [4 /*yield*/, fetchPostAsResponse(baseUrl + "/" + "v1/tokens" /* Tokens */, body, { headers: headers })];
            case 3:
                response = _b.sent();
                if (!response || !response.ok) {
                    return [2 /*return*/, Promise.reject()];
                }
                token = getTokenFromHeaders(response.headers);
                _b.label = 4;
            case 4:
                if (!token) {
                    return [2 /*return*/, Promise.reject('Authorization header was not found in auth token response')];
                }
                storage.setItem("web-store-auth-token" /* WebStoreAuthToken */, token);
                return [2 /*return*/, token];
        }
    });
}); };
